import React from "react";
import Grid from "@mui/material/Grid";
import ValidatorTextField from "@/src/components/FormFields/ValidatorTextField";
import { isRequired, postalCodeDefault, requiredValidator } from "@/src/services/validationRules";
import FormLegend from "@/src/components/Form/Common/FormLegend/FormLegend";
import wizardStyle from "@/src/components/Form/wizardStyle";

type PostOfficeBoxAddressProps = {
  path: string;
  headline?: string;
  fieldsAreRequired?: boolean;
  disabled?: boolean;
};
const PostOfficeBoxAddress = ({ path, headline = "Wo wohnen Sie?", fieldsAreRequired = true, disabled = false }: PostOfficeBoxAddressProps) => {
  return (
    <>
      {headline && (
        <Grid sx={wizardStyle.gridTopSpaced} size={12}>
          <FormLegend>{headline}</FormLegend>
        </Grid>
      )}
      <Grid size={12}>
        <ValidatorTextField
          name={`${path}.postOfficeBoxNumber`}
          label="Postfach"
          disabled={disabled}
          validators={fieldsAreRequired ? [requiredValidator("Bitte geben Sie das Postfach an")] : []}
        />
      </Grid>
      <Grid
        sx={wizardStyle.gridSpace}
        size={{
          xs: 12,
          sm: 6
        }}>
        <ValidatorTextField
          name={`${path}.postOfficeBoxPostalCode`}
          label="Postfach PLZ"
          disabled={disabled}
          validators={fieldsAreRequired ? [requiredValidator("Bitte geben Sie die Postleitzahl an"), postalCodeDefault] : [postalCodeDefault]}
        />
      </Grid>
      <Grid
        size={{
          xs: 12,
          sm: 6
        }}>
        <ValidatorTextField
          name={`${path}.postOfficeBoxAddressLocality`}
          label="Postfach Ort"
          disabled={disabled}
          validators={fieldsAreRequired ? [{ validator: isRequired, message: "Bitte geben Sie den Ort an" }] : []}
        />
      </Grid>
    </>
  );
};

export default PostOfficeBoxAddress;
